export default "__VITE_ASSET__1yTXO3u___"